<template>
  <div>
    <div class="mui-card">
      <h4 style="display: inline-block;text-align: center;width: 100%">{{ name }}采集说明（标准）</h4>
      <div class="mui-card-content" v-if="facilitiesType === 8">
        &nbsp;&nbsp;&nbsp;&nbsp;无障碍电梯是适合乘轮椅者、视残者或担架床可进入和使用的电梯。 在公共建筑中配备电梯时，必须设无障碍电梯
        <hr>
        &nbsp;&nbsp;&nbsp;&nbsp;候梯厅深度不宜小于1.5m；按钮高度0.90-1.10m；电梯门洞净宽度不宜小于0.90m；电梯出入口处宜设置盲道；侯梯厅应设电梯运行显示装置和抵达音响。
        <hr>
        &nbsp;&nbsp;&nbsp;&nbsp;电梯门开启净宽不小于0.80m；轿厢最小规格为深度不应小于1．40m，宽度不应小于1．10m；中型规格为深度不应小于1．60m，宽度不应小于1．40m；医疗建筑与老人建筑宜选用病床专用电梯；轿厢正面和侧面可设高0.80-0.85m的扶手；轿厢侧面可设高0.90-1.10m带盲文的选层按钮；轿厢正面高0.90m处至顶部可安装镜子；轿厢上、下运行及到达应有清晰显示和报层音响。
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'facilitiesIntroduce',
  data () {
    return {

    }
  },
  props: ['name', 'facilitiesType']
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Facilities/facilitiesIntroduce.vue